<script>
    import Icon from 'views/components/icon/Icon.svelte'
    import ChapterView from 'views/pages/groups/show/chapterView/ChapterView'

    export let model

    const title = model.get('title')
    const chapters = model.getChildren()
    const localStorageKey = `activeModule:${Backbone.Model.user.id}:${model.getGroupModel().id}`

    function activate(element) {

        // If the URL contains a module, open it and scroll to it
        const targetModuleId = parseInt(new URLSearchParams(location.search).get('module'))
        if (isFinite(targetModuleId)) {
            if (model.id === targetModuleId) {
                element.open = true
                element.scrollIntoView()
            }
            return
        }

        // If this is the only visible module, open it
        const modulesWithChapters = model.collection.filter(module => module.getChildren().length)
        if (modulesWithChapters.length === 1) {
            element.open = true
            return
        }

        // For students, pre-open the module from local storage
        if (ACL.checkRole(ACL.roles.STUDENT)) {
            const storedModuleId = parseInt(window.localStorage.getItem(localStorageKey))
            if (isFinite(storedModuleId) && model.id === storedModuleId) {
                element.open = true
            }
        }
    }

    function addChapter(element, chapter) {
        const chapterView = new ChapterView({ model: chapter })
        element.append(chapterView.el)
    }

    function onToggle(event) {
        if (event.target.open && ACL.checkRole(ACL.roles.STUDENT)) {
            window.localStorage.setItem(localStorageKey, model.id)
        }
    }
</script>

{#if chapters.length > 0}
    <details class="container" use:activate on:toggle={onToggle}>
        <summary class="module">
            <div class="icon">
                <Icon name={model.getIcon()}></Icon>
            </div>
            <div>
                <div class="name">{title}</div>
                <div class="chapter-count">{window.i18n.sprintf(window.i18n.ngettext('%d chapter', '%d chapters', chapters.length), chapters.length)}</div>
            </div>
            <div class="arrow">
                <Icon name="arrow-down"></Icon>
            </div>
        </summary>
        <div class="chapters">
            {#each chapters as chapter (chapter.id)}
                <div use:addChapter={chapter}></div>
            {/each}
        </div>
    </details>
{/if}

<style lang="scss">/*
* Scut, a collection of Sass utilities
* to ease and improve our implementations of common style-code patterns.
* v1.0.1
* Docs at http://davidtheclark.github.io/scut
*/
/* TODO implement tooltip arrow */
.container {
  margin-bottom: 16px;
  border-radius: 12px;
  border: 1px solid hsl(40, 4%, 84%);
  background-color: rgba(255, 255, 255, 0.5);
}
.container .module {
  display: flex;
  align-items: center;
  padding: 16px;
  position: sticky;
  top: 0;
  z-index: 3;
  background-color: #fff;
  border-radius: 16px;
  transition: 0.25s background-color;
}
.container .module:hover {
  color: hsl(205, 60%, 44%);
}
.container .module .icon {
  display: flex;
  margin-right: 12px;
  padding: 8px;
  border-radius: 12px;
  background-color: rgba(44.88, 123.42, 179.52, 0.1);
}
.container .module .icon :global(svg) {
  width: 16px;
  height: 16px;
  fill: hsl(205, 60%, 44%);
}
.container .module .name {
  font-size: 20px;
  font-weight: 600;
}
.container .module .chapter-count {
  color: rgba(18, 45, 64, 0.5);
}
.container .module .arrow {
  display: flex;
  margin-left: auto;
}
.container .module .arrow :global(svg) {
  width: 20px;
  height: 20px;
  fill: currentColor;
}
.container[open] .module {
  background-color: rgb(247.41375, 245.941125, 244.73625);
}
.container[open] .module .arrow :global(svg) {
  transform: rotate(180deg);
}
.container .chapters {
  padding-left: 16px;
  padding-right: 16px;
}</style>
